const gsapController = async function () {
    const homepage = document.querySelector('.hero-homepage') !== null,
        skewImages = document.querySelector('.animated-image') !== null,
        burger = document.querySelector('#menu-burger') !== null;;

    if (homepage || skewImages || burger) {
        let gsap = await (await import('gsap')).default;
        let ScrollTrigger = await (await import('gsap/ScrollTrigger')).default;
        gsap.registerPlugin(ScrollTrigger)

        if (homepage) {
            let homepageAnimation = await (await import( /* webpackPreload: true */ './gsap/homepage')).default;
            homepageAnimation(gsap);
        }

        if (skewImages) {
            let skewImagesAnimation = await (await import('./gsap/skew-images')).default;
            skewImagesAnimation(gsap);
        }

        if (burger) {
            let burgerAnimation = await (await import('./gsap/sidebar-menu')).default;
            burgerAnimation(gsap);
        }

    }
}

export const init = gsapController;